import { createContext, ReactNode, useCallback, useContext, useEffect, useState } from 'react'
import { api } from './api'
import { SiteSettings } from './types'

const EMPTY: SiteSettings = { sidebarTags: [], about: { heading: 'About', text: '', images: [] }, titleImage: null }

const SettingsContext = createContext<{ settings: SiteSettings; reload: () => void }>({ settings: EMPTY, reload: () => {} })

/** Sidebar tags, the title image and the About page, loaded once per visit */
export function SettingsProvider({ children }: { children: ReactNode }) {
  const [settings, setSettings] = useState<SiteSettings>(EMPTY)
  const reload = useCallback(() => {
    api
      .get<SiteSettings>('/api/settings')
      .then(setSettings)
      .catch(() => {})
  }, [])
  useEffect(() => {
    reload()
  }, [reload])
  return <SettingsContext.Provider value={{ settings, reload }}>{children}</SettingsContext.Provider>
}

export const useSettings = () => useContext(SettingsContext)
